import React, { Component } from 'react';

import {Cam, Text} from './shared/Icons';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import UAParser from 'ua-parser-js';

class Unsupported extends Component {

  getNotSupportedMessage() {
    const ua = new UAParser();

    const os = ua.getOS();
    const browser = ua.getBrowser();

    if (os.name.toLowerCase() === 'ios') {
      if (browser.major < 11) {
        return (
          <div>
            <p style={{textTransform: 'none'}}>
              <FormattedHTMLMessage
                id='Client.Unsupported.UpdateiOS'
                defaultMessage='Diese Applikation benötigt mindestens iOS Version <strong>11</strong>. Ihr Gerät ist derzeit auf Version <strong>{major}</strong>.'
                values={{
                  major: browser.major + ''
                }} />
            </p>
            <p style={{
              margin:'10px 30px 0px 30px',
              textTransform:'none'
            }}>
              <FormattedMessage
                id='Client.Unsupported.OSUpdateInstruction'
                defaultMessage='Wir empfehlen ein Update auf Ihrem Gerät durchzuführen:'
              />
            </p>
            <p style={{
              margin:'40px 30px 60px 30px',
              textTransform: 'none',
              fontWeight:'bold'
              }}>
              <a href="https://support.apple.com/ios/update"
                style={{
                  color: 'inherit',
                  display: 'inline-block',
                }}
              >
                <img src={`update-ios-${this.props.locale}.png`} style={{maxWidth: '90vw', margin:'auto', marginBottom: '3em'}}/>
                <br/>
                <FormattedMessage
                  id='Client.Unsupported.UpdateOSInstruction'
                  defaultMessage='Update-Anleitung auf Apple.com'
                />
              </a>
            </p>
          </div>
        )
      }
      else if (!navigator.mediaDevices) {
        return (
        <div>
          <p style={{textTransform: 'none'}}>
            <FormattedHTMLMessage
              id='Client.Unsupported.NeedsSafari'
              defaultMessage='Sie haben diese Webseite in einer Fremdapplikation geöffnet, es wird jedoch der Safari-Browser benötigt.'
              values={{
                major: os.major
              }} />
          </p>
          <p style={{
            margin:'10px 30px 0px 30px',
            textTransform:'none'
          }}>
            <FormattedMessage
              id='Client.Unsupported.OpenInSafari'
              defaultMessage='Bitte öffnen Sie diese Webseite mit dem Safari-Browser auf Ihrem Gerät:'
            />
          </p>
          <p style={{
            margin:'40px 30px 60px 30px',
            textTransform: 'none',
            fontWeight:'normal'
            }}>
            <img src={`open-in-safari-${this.props.locale}.png`} style={{maxWidth: '90vw', marginBottom: '3em' }}/><br/>
            <FormattedMessage
              id='Client.Unsupported.OpenInSafariButton'
              defaultMessage='Die Darstellung und Position des Buttons kann auf Ihrem Gerät abweichen.'
            />
          </p>
        </div>);
      }
    }

    return (
      <div>
        <p>
          <FormattedMessage
            id='Client.Unsupported.BrowserNotSupported'
            defaultMessage='Ihr Browser unterstützt die verwendeten Technologien leider nicht.'
            />
        </p>
        <p style={{textTransform: 'none'}}>
          <FormattedMessage
            id='Client.Unsupported.BrowserInstruction'
            defaultMessage='Bitte verwenden Sie {browser1} oder {browser2}.'
            values={{
              browser1: <a style={{textDecoration: 'none', color: 'inherit'}}href="https://www.mozilla.org/de/firefox/new/">Firefox</a>,
              browser2: <a style={{textDecoration: 'none', color: 'inherit'}}href="https://www.google.de/chrome/">Chrome</a>
            }} />
        </p>
        <p style={{
          margin:'10px 30px 0px 30px',
          textTransform:'none'
        }}>
          <FormattedMessage
            id='Client.Unsupported.BrowserDownloadInstruction'
            defaultMessage='Wir empfehlen den folgenden Browser zu installieren:'
          />
        </p>
        <p style={{
          margin:'40px 30px 60px 30px',
          textTransform: 'none',
          fontWeight:'bold'
          }}>
          <a href="https://www.google.de/chrome/"
            style={{
              textDecoration: 'none',
              color: 'inherit',
              display: 'inline-block',
            }}
          >
            <img src="chrome.png" style={{maxWidth: '60px', marginBottom: '10px', width: '50vw'}}/><br/>
            <FormattedMessage
              id='Client.Unsupported.BrowserChromeDownload'
              defaultMessage='Google Chrome herunterladen'
            />
          </a>
        </p>
      </div>
    )
  }

  setLocale(lang) {
    if (window.localStorage) {
      window.localStorage.setItem('language', lang);
      window.location.reload();
    }
  }

  render() {
    let user = null;

    if (this.props.info) {
      for (let i = 0; i < this.props.info.length; i++) {
        if (this.props.info[i].id === this.props.user) {
          user = this.props.info[i];
          break;
        }
      }
    }

    const localeLogo = 'Logo_' + this.props.locale;
    const notSupported = this.getNotSupportedMessage();

    return (
      <div className="lobby unsupported">
        <div className="lobby-overlay"></div>
        <div className="lobby-overlay-shadow"></div>
        <div className="lobby-content">
          <img className="logo" src={localeLogo + '.png'} />
          {notSupported}
          <p></p>
          {user &&
            <div className="contact">
              <span>
                <FormattedMessage
                  id='Client.Unsupported.HelpMsgContact'
                  defaultMessage='Ihr Kontakt'
                />
              </span>
              <span className="name">{user.name}</span><br/>
              <span>
                <FormattedMessage
                  id='Client.Unsupported.HelpMsgReachable'
                  defaultMessage='ist erreichbar unter'
                />
              </span><br/><br/>
              <span><a style={{textDecoration: 'none', fontSize: '2em', color: 'inherit'}} href={"tel:" + user.phone}>{user.phone}</a></span>
            </div>}
          <div className="languageswitcher">
            <ul>
              <li onClick={() => this.setLocale('de')} className={this.props.locale === 'de' ? 'active' : ''} data-lang='de'>Deutsch</li>
              <li onClick={() => this.setLocale('fr')} className={this.props.locale === 'fr' ? 'active' : ''} data-lang='fr'>Français</li>
              <li onClick={() => this.setLocale('it')} className={this.props.locale === 'it' ? 'active' : ''} data-lang='it'>Italiano</li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
};

export default Unsupported;


// WEBPACK FOOTER //
// ./src/Unsupported.js